import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { defineStore } from 'pinia';
import { PD_URL } from '~/core/constants';
import { ReservedQueryKey } from '~/core/enums/routing';
import { MT_APP_URL } from '~/core/i18n/constants';
import { COUNTRY_CODE } from '~/core/i18n/constants/countryCode';
import showError from '~/bridge/showError';
import useLocaleStore from '~/stores/useLocaleStore';
import { AuthApi } from '~/features/Authorization/api';
export default defineStore('countries', function () {
  var locale = useLocaleStore();
  var countries = ref(null);
  var phoneInput = ref('');
  var selectedCountry = ref(null);
  var countriesItems = ref([]);
  var isCountrySelectMenuActive = ref(false);
  var pdUrl = computed(function () {
    var _selectedCountry$valu;
    return (_selectedCountry$valu = selectedCountry.value) !== null && _selectedCountry$valu !== void 0 && _selectedCountry$valu.pdDomain ? "https://".concat(selectedCountry.value.pdDomain) : PD_URL;
  });
  var $route = useRoute();
  var _useNuxtApp = useNuxtApp(),
    $captureException = _useNuxtApp.$captureException;
  function fetchCountries() {
    return _fetchCountries.apply(this, arguments);
  }
  function _fetchCountries() {
    _fetchCountries = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$AuthApi$getCou, data, ruCountry, iso, _countriesItems$value;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (!countries.value) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            _context.next = 5;
            return AuthApi.getCountries();
          case 5:
            _yield$AuthApi$getCou = _context.sent;
            data = _yield$AuthApi$getCou.data;
            countries.value = data;

            // NOTE: По умолчанию страны отсортированы по алфавиту.
            //       Для RU сортируем также по алфавиту, но Россия - на первом месте
            if (process.env.domain === 'RU') {
              countriesItems.value = data.sort(function (itemA, itemB) {
                if (itemB.iso === 'RU') {
                  return 1;
                }
                if (itemA.iso === 'RU') {
                  return -1;
                }
                if (itemA.name.toLowerCase() < itemB.name.toLowerCase()) {
                  return -1;
                }
                if (itemA.name.toLowerCase() > itemB.name.toLowerCase()) {
                  return 1;
                }
                return 0;
              });
            } else {
              countriesItems.value = data;
            }
            ruCountry = countriesItems.value.find(function (_ref) {
              var iso = _ref.iso;
              return iso === 'RU';
            });
            if (ruCountry) {
              ruCountry.maskForInput = '&## ###-##-##';
            }
            iso = $route.query[ReservedQueryKey.PreselectedCountry] || locale.currentDomainCountry;
            if (iso) {
              selectedCountry.value = (_countriesItems$value = countriesItems.value.find(function (item) {
                return item.iso === iso;
              })) !== null && _countriesItems$value !== void 0 ? _countriesItems$value : countriesItems.value[0];
            } else {
              selectedCountry.value = countriesItems.value[0];
            }
            _context.next = 19;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            $captureException(_context.t0, {
              component: 'useCountriesStore',
              method: 'fetchCountries'
            });
            showError(_context.t0);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 15]]);
    }));
    return _fetchCountries.apply(this, arguments);
  }
  function handleSelectCountry(_x) {
    return _handleSelectCountry.apply(this, arguments);
  }
  function _handleSelectCountry() {
    _handleSelectCountry = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(item) {
      var newMtAppUrl, nextQuery, newURL;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            isCountrySelectMenuActive.value = false;
            newMtAppUrl = '';
            if (item.iso !== locale.currentDomainCountry) {
              if (MT_APP_URL[item.iso]) {
                newMtAppUrl = MT_APP_URL[item.iso];
              } else if (item.iso === COUNTRY_CODE.RU && locale.currentDomainCountry !== COUNTRY_CODE.RU) {
                newMtAppUrl = MT_APP_URL[COUNTRY_CODE.RU];
              } else if (item.iso !== COUNTRY_CODE.RU && locale.currentDomainCountry !== COUNTRY_CODE.other) {
                newMtAppUrl = MT_APP_URL[COUNTRY_CODE.other];
              }
            }
            if (!newMtAppUrl) {
              _context2.next = 7;
              break;
            }
            nextQuery = typeof $route.query.next === 'string' ? "&next=".concat(encodeURIComponent($route.query.next)) : '';
            window.location.replace("".concat(newMtAppUrl, "/authorization/?").concat(ReservedQueryKey.PreselectedCountry, "=").concat(item.iso).concat(nextQuery));
            return _context2.abrupt("return");
          case 7:
            if (!(!selectedCountry.value || selectedCountry.value.iso !== item.iso)) {
              _context2.next = 15;
              break;
            }
            selectedCountry.value = item;

            // TODO: можно заменить на composable из VueUse
            // NOTE: Смена значения query без перезагрузки страницы.
            //       Код страны - это всегда 2 заглавные латинские буквы
            newURL = new URL(window.location.href);
            newURL.search = newURL.search.replace(/preselected_country=[A-Z]{2}/gm, "preselected_country=".concat(item.iso));
            window.history.pushState({
              path: newURL.href
            }, '', newURL.href);

            // NOTE: Ждём пока изменится маска новой выбранной страны
            _context2.next = 14;
            return nextTick();
          case 14:
            phoneInput.value = '';
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _handleSelectCountry.apply(this, arguments);
  }
  return {
    countries: countries,
    phoneInput: phoneInput,
    selectedCountry: selectedCountry,
    countriesItems: countriesItems,
    isCountrySelectMenuActive: isCountrySelectMenuActive,
    pdUrl: pdUrl,
    fetchCountries: fetchCountries,
    handleSelectCountry: handleSelectCountry
  };
});